/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Amount_PositiveInputs */

const vi_validation_amount_positive = /** @type {(inputs: Validation_Amount_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền phải lớn hơn 0`)
};

/**

* @param {Validation_Amount_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_amount_positive = /** @type {((inputs?: Validation_Amount_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Amount_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_amount_positive(inputs)
});